var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderEmptyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 179.057,
    height: 148.926,
    viewBox: "0 0 179.057 148.926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3852",
    "data-name": "Group 3852",
    transform: "translate(-5812 15821.907)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9467",
    "data-name": "Rectangle 9467",
    width: 117,
    height: 27,
    transform: "translate(5844 -15766)",
    fill: "rgba(0,0,0,0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5184",
    "data-name": "Path 5184",
    d: "M4902.564-15991.859v26.5s6.717-.225,7.409,0a10.258,10.258,0,0,0,3.362-.455c.356-.108,2.938-1.5,2.938-1.5l1.947-3.042a25.983,25.983,0,0,0,.619-3.222,39.417,39.417,0,0,0-2.122-5c-.706-1.216-6.744-9.939-6.744-9.939a26.432,26.432,0,0,0-2.783-2.308c-.5-.2-2.645-1.035-2.645-1.035Z",
    transform: "translate(1058 226.602)",
    fill: "rgba(0,0,0,0.19)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3851",
    "data-name": "Group 3851",
    transform: "translate(4712.164 -16415.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9465",
    "data-name": "Rectangle 9465",
    transform: "translate(1217.347 595.923)",
    fill: "none",
    stroke: "#c3c3c3",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.799,
    height: 14.02,
    rx: 7.01,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 12.799,
    height: 12.02,
    rx: 6.01,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9466",
    "data-name": "Rectangle 9466",
    transform: "translate(1233.519 605.49)",
    fill: "none",
    stroke: "#c3c3c3",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.799,
    height: 14.02,
    rx: 7.01,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 12.799,
    height: 12.02,
    rx: 6.01,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5177",
    "data-name": "Path 5177",
    d: "M-3609.681-9843.844v-73.332l10.313-15.654s1.63-3.688,8.1-3.564,112.315,0,112.315,0,7.569.2,11.008,5.136,8.927,14.083,8.927,14.083v73.332",
    transform: "translate(4723.681 10584.977)",
    fill: "none",
    stroke: "#343434",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5178",
    "data-name": "Path 5178",
    d: "M-3609.681-9907.957a7.444,7.444,0,0,0,7.573,6.238c6.643-.039,136.8,0,136.8,0s5.337-1.059,6.3-6.072",
    transform: "translate(4723.681 10578.688)",
    fill: "none",
    stroke: "#343434",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5179",
    "data-name": "Path 5179",
    d: "M-3586.471-9936.4v27.839",
    transform: "translate(4718.549 10584.977)",
    fill: "none",
    stroke: "#343434",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5180",
    "data-name": "Path 5180",
    d: "M-3437.237-9936.4v27.839",
    transform: "translate(4685.555 10584.977)",
    fill: "none",
    stroke: "#343434",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5181",
    "data-name": "Path 5181",
    d: "M-3593.06-9936.4c-.43-.088-5.6,3.115-5.6,3.115l-2.9,3.547-7.561,13.091.258,3.325,2.327,3.363a5.89,5.89,0,0,0,1.679,1.281c.6.153,4.981.672,5.441.646s6.177.161,6.356,0a8.721,8.721,0,0,1,2.048,0l-.324-28.369Z",
    transform: "translate(4723.557 10584.978)",
    fill: "rgba(52,52,52,0.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9463",
    "data-name": "Rectangle 9463",
    width: 41.282,
    height: 10.905,
    rx: 5.452,
    transform: "translate(1165.16 695.623)",
    fill: "rgba(0,0,0,0.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5182",
    "data-name": "Path 5182",
    d: "M-3543.061-9931.846s27.5,2.389,34.29-10.09-2.331-18.918-9.455-19.061-16.445,14.328-1.278,20.385,23.458-4.911,38.184-34.259",
    transform: "translate(4708.951 10593.482)",
    fill: "none",
    stroke: "#c3c3c3",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9464",
    "data-name": "Rectangle 9464",
    transform: "translate(1234.301 598.775) rotate(31)",
    fill: "none",
    stroke: "#343434",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.01,
    height: 17.915,
    rx: 3.505,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 5.01,
    height: 15.915,
    rx: 2.505,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5183",
    "data-name": "Path 5183",
    d: "M-3456.237-10006.346l2.967,7.008,7.382-1.473",
    transform: "translate(4689.756 10600.441)",
    fill: "none",
    stroke: "#343434",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9462",
    "data-name": "Rectangle 9462",
    width: 41.282,
    height: 10.905,
    rx: 5.452,
    transform: "translate(1169.054 698.738)",
    fill: "#ff091b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5164",
    "data-name": "Path 5164",
    d: "M-4244.6-11230h179.057",
    transform: "translate(10056.598 -4444.481)",
    fill: "none",
    stroke: "#343434",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderEmptyIcon);
export default __webpack_public_path__ + "static/media/order_empty_icon.7996bc50a9191425dd808c849b022351.svg";
export { ForwardRef as ReactComponent };